<template>
    <v-form v-model="valid" ref="form">
        <v-container fluid>
            <div class="headline">{{__('labels.upload')}}</div>
            <div class="subheading">{{__('labels.upload_subtitle')}}</div>
            <v-layout row wrap>
                <v-flex xs12>
                    <s-dropzone name="receipts" :item="receipts"></s-dropzone>
                </v-flex>
                <v-flex>
                    <p v-html="__('messages.email_receipts', {email: plEmail})"></p>
                    <p>{{__('messages.mail_receipts')}}<a @click="downloadLetterHead">{{__('messages.mail_receipts_link')}}</a>.</p>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'
    import {mapGetters} from 'vuex'

    const objectToFormData = require('object-to-formdata/index');

    export default {
        name: "UploadStep",
        computed: {
            ...mapState('form', [
                "address",
                'locations',
                "invoice",
                "bankAccount",
                'event',
                'events',
                'receipts',
            ]),
            plEmail() {
                let event = _.find(this.events, {id: this.event});
                if (event) {
                    return event.pl_email
                }
                return ''
            }
        },
        data() {
            return {
                valid: false,
                rules: this.$validation.create({}
                )
            }
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapActions('form', [
                'setError',
            ]),
          ...mapGetters('stepper', [
            'locale'
          ]),
            nextButtonClick() {
                if (this.$refs.form.validate()) {
                    this.nextStep();
                } else {
                    this.setError(this.__('messages.form_invalid'));
                }
            },
            downloadLetterHead() {
                const formData = objectToFormData(
                    {
                        address: this.address,
                        invoice: this.invoice,
                        event: this.event,
                        bankAccount: this.bankAccount
                    },
                );
                if (this.$refs.form.validate()) {
                    axios.post((this.locale()==='en'? '/en':'')+'/letterhead/download', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                        let blob = this.b64toBlob(response.data.pdf, 'application/pdf');
                        let fileName = 'Briefkopf_' + this.invoice.invoice_number + '_' + _.find(this.events, {id: this.event}).name + '_' + this.address.last_name + '_' + this.invoice.invoice_date + '.pdf';
                        fileName = fileName.normalize('NFD').replace(/[ ]/g, '_').replace(/[^A-Za-z0-9_\-\.]/g, '');
                        if (window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, fileName);
                            window.navigator.msSaveOrOpenBlob(blob, fileName);
                        } else {
                            const link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }
                    }).catch(() => {
                        this.setError(this.__('messages.unexpected_error'));
                    });
                }
            },
            b64toBlob(b64Data, contentType = '', sliceSize = 512) {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }
        },
    }
</script>

<style scoped>

</style>
